// @ constants
const {
    GET_PERSONETICS_CLICKED_TEASER,
    GET_PERSONETICS_INBOX_INSIGHTS_FAILURE,
    GET_PERSONETICS_INBOX_INSIGHTS_REQUEST,
    GET_PERSONETICS_INBOX_INSIGHTS_SUCCESS,
} = require('constants/actionTypes');
const {
    CTX_ID,
    EVENT_TYPE_PRESENTED_VALUE,
    EVENT_TYPE_PRESENTED,
    GET_INBOX_INSIGHTS,
    PROTOCOL_VERSION,
    SEND_EVENT,
} = require('constants/personetics');
// @ utilities
const { APIPost } = require('utilities/APIRequestHelper');
const { getLanguage } = require('core/i18n').i18n;

const getPersoneticsInboxInsightsRequest = () => ({
    type: GET_PERSONETICS_INBOX_INSIGHTS_REQUEST
});

const getPersoneticsInboxInsightsSuccess = (response, clickedId) => ({
    type: GET_PERSONETICS_INBOX_INSIGHTS_SUCCESS,
    payload: {
        response,
        clickedId
    }
});

const getPersoneticsInboxInsightsFailure = (error) => ({
    type: GET_PERSONETICS_INBOX_INSIGHTS_FAILURE,
    payload: {
        error
    }
});

const updatePersoneticsStatus = () => (dispatch, getState) => {
    const immInboxInsights = getState().personeticsInboxInsights.get('inboxInsights');
    const eventsInfoList = immInboxInsights.map((insight) => {
        return {
            type: EVENT_TYPE_PRESENTED,
            params: {
                value: EVENT_TYPE_PRESENTED_VALUE,
                insightId: insight.get('insightId'),
                instanceId: insight.get('id')
            }
        }
    });
    const params = {
        query: {
            type: SEND_EVENT,
            protocolVersion: PROTOCOL_VERSION,
            ctxId: CTX_ID,
            lang: getLanguage().toLowerCase(),
            eventsInfoList
        }
    };
    return APIPost({
        dispatch,
        endpoint: 'personeticsIntegrationURL',
        params
    })
}

const getPersoneticsInboxInsights = () => (dispatch) => {
    dispatch(getPersoneticsInboxInsightsRequest());
    const params = {
        query: {
            type: GET_INBOX_INSIGHTS,
            protocolVersion: PROTOCOL_VERSION,
            autoGenerate: true,
            ctxId: CTX_ID,
            lang: getLanguage().toLowerCase()
        }
    };

    return APIPost({
        dispatch,
        endpoint: 'personeticsIntegrationURL',
        params
    })
        .then(response => {
            dispatch(getPersoneticsInboxInsightsSuccess(response));
            if (response.status === '200' && response.statusMessage === 'ok' && response.insights.length > 0) {
                dispatch(updatePersoneticsStatus())
            }
        })
        .catch(response => {
            dispatch(getPersoneticsInboxInsightsFailure(response));
        });
};

const setClickedTeaser = (clickedId) => (dispatch) => {
    dispatch({
        type: GET_PERSONETICS_CLICKED_TEASER,
        payload: {
            clickedId
        }
    });
};

module.exports = {
    getPersoneticsInboxInsights,
    setClickedTeaser
}